import { useTranslation } from 'next-i18next'
import { Tab } from '@headlessui/react'
import CustomerReviews from './customer-reviews'
import QuestionAndAnswers from './questions-and-answers'
import { FC } from 'react'
import { useQuery } from 'react-query'
import pdpQuestionAnswersService from '@services/pdp-questionanswer-service'
import { REVIEWS_SECTION } from '@constants/index'

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

interface ProductReviewsAndQuestionProps {
  sku: string
  product_id?: string
  reviews: any
}

const ProductReviewsAndQuestion: FC<ProductReviewsAndQuestionProps> = ({
  sku,
  product_id,
  reviews,
}) => {
  const { t } = useTranslation()
  const tabHeading = ['text-customer-reviews', 'text-question-and-answers']

  const {
    data: questionsData,
    error,
    isLoading,
  } = useQuery<any, Error>(
    ['items', product_id],
    () => pdpQuestionAnswersService.getQuestionAnswersData(product_id), // Function that fetches the data
  )

  return (
    <div className=" pb-5 pt-9 px-[8%]" id={REVIEWS_SECTION}>
      <h1 className="text-brand-dark font-medium opacity-80  text-2xl font-sofia">
        {t('text-reviews-and-questions')}
      </h1>
      <Tab.Group>
        <Tab.List className="block border-b border-gray-300  whitespace-nowrap overflow-x-auto overflow-y-hidden mt-5 h-[37px]">
          {tabHeading.map((item, index) => (
            <Tab
              key={item}
              className={({ selected }) =>
                classNames(
                  'font-poppins relative inline-block font-medium transition-all text-sm lg:text-17px leading-5  focus:outline-none pb-3 hover:text-brand px-5 ',
                  selected
                    ? 'text-brand-dark border-brand-dark  after:absolute after:w-full after:h-0.5 after:bottom-0 after:translate-y-[1px] after:ltr:left-0 after:rtl:right-0 after:bg-brand'
                    : 'text-brand-gray',
                )
              }
            >
              {index === 0 && reviews?.reviewData?.length} {t(item)}
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="">
          <Tab.Panel className="">
            <CustomerReviews sku={sku} reviews={reviews} />
          </Tab.Panel>
          <Tab.Panel className="">
            {product_id && (
              <QuestionAndAnswers
                data={
                  questionsData === undefined
                    ? null
                    : Array.isArray(questionsData)
                    ? questionsData
                    : [questionsData]
                }
                product_id={product_id}
              />
            )}
            {error?.message && (
              <p className="text-red-500 text-center p-4">{error?.message}</p>
            )}
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  )
}

export default ProductReviewsAndQuestion
